import { render } from "./App.vue?vue&type=template&id=4e4205a8&bindings={\"formula\":\"setup\",\"setFormulaDebounced\":\"setup\",\"rendered\":\"setup\",\"url\":\"setup\",\"submit\":\"setup\",\"responseState\":\"setup\",\"clipboard\":\"setup\",\"copied\":\"setup\",\"clipboardCode\":\"setup\",\"shortId\":\"setup\",\"copyShared\":\"setup\",\"layout\":\"setup\",\"setLayout\":\"setup\",\"modalUp\":\"setup\",\"pushExample\":\"setup\",\"routeParams\":\"setup\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=postcss"
script.render = render

export default script